"use client";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loader/Loader";
import {
  useClinicSignupMutation,
  useUserSignupMutation,
} from "../../Redux/apis/auth";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import { userData } from "@/Redux/apis/userData";
import { setToken } from "@/Redux/slice/token";
import { getCurrentSystemTimezone } from "@/utils/common";
import { toast } from "react-toastify";
const SignUp = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);
  const [isResetting, setIsResetting] = useState(false);
  const [npmErrorPhysician, setNpmErrorPhysician] = useState();
  const [npmErrorClinic, setNpmErrorClinic] = useState();
  const router = useRouter();
  const searchParams = useSearchParams()
  const redirectURL = searchParams.get("redirect")
  const token = useSelector((state) => state?.token?.token);
  const users = useSelector((state) => state?.userData?.userData?.user);
  const pathname = usePathname()
  const [signup, setSignup] = useState({
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    confirmPassword: "",
    npi_number: null,
  });
  const [clinicSignup, setClinicSignup] = useState({
    email_cl: "",
    firstName_cl: "",
    lastName_cl: "",
    password_cl: "",
    confirmPassword_cl: "",
    npi_number_cl: null,
    hospital_name_cl: "",
  });
  const [userSignup, response] = useUserSignupMutation();
  const [clinicSignupApi, clinicData] = useClinicSignupMutation();
  const [error, setError] = useState("")
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setValue(name, e.target.value);
    setSignup({
      ...signup,
      [name]: value,
    });
  };
  const onSubmit = async (e) => {
    setError("")
    setLoading(true); 
    const payload = {
      email: signup?.email,
      firstName: signup?.firstName,
      lastName: signup?.lastName,
      npi_number: signup?.npi_number,
      password: signup?.password,
      confirmPassword: signup?.confirmPassword,
      type: activeTab === 1 ? "physician" : "clinic",
      timezone: getCurrentSystemTimezone()
    };
    console.log(payload, 'payload');
    await userSignup(payload);
  };
  const handleRouting = (path) => {
    if (redirectURL) {
      router.push(path + "?redirect=" + redirectURL)
    } else {
      router.push(path)
    }
  }
  useEffect(() => {
    const handleResponse = async () => {
      if (response.isLoading) {
        setLoading(true);
      } else if (!response?.isLoading && response?.isSuccess) {
        const token = response?.data?.token;
        const id = response?.data?.reps;

        Cookies.set("token", token);
        Cookies.set("isReps", id);
        dispatch(setToken(token));
        dispatch(userData({ token })); // Wait for userData to be updated

        // Keep loading true until navigation completes
        if (response?.data?.isVerifiedAccount === false) {
          // Will navigate to two-factor verification
          handleRouting("/provider/two-factor-verification")
          // Loading will be reset by history.pushState override in useEffect
        } else {
          if (
            response?.data?.isAccountData === false &&
            response?.data?.type === "physician"
          ) {
            // Will navigate to profile settings
            handleRouting("/provider/profile-setting")
            // Loading will be reset by history.pushState override in useEffect
          } else {
            // No navigation, so reset loading state
            setLoading(false);
            setError("account already setup please login")
          }
        }
        toast.success("Verify your email");
      } else if (
        response?.isError &&
        response?.status === "rejected" &&
        response?.error?.status === 400
      ) {
        if (response?.error?.data?.message === "NPI number is not valid" || response?.error?.data.message === "NPI belongs to another user") {
          setNpmErrorPhysician({
            error: response?.error?.data?.message,
          });
        } else {
          setError(response?.error?.data.message)
        }
        setLoading(false);
      }
    };

    handleResponse();
  }, [response, dispatch, router]);
  const onChangeHandlerClinic = (e) => {
    const { name, value } = e.target;
    setValue(name, e.target.value);
    setClinicSignup({
      ...clinicSignup,
      [name]: value,
    });
  };
  const onSubmitClinic = async (e) => {
    const payload = {
      email: clinicSignup?.email_cl,
      firstName: clinicSignup?.firstName_cl,
      lastName: clinicSignup?.lastName_cl,
      npi_number: clinicSignup?.npi_number_cl,
      password: clinicSignup?.password_cl,
      confirmPassword: clinicSignup?.confirmPassword_cl,
      type: activeTab === 1 ? "physician" : "clinic",
      hospital_name: clinicSignup?.hospital_name_cl,
      timezone: getCurrentSystemTimezone()
    };
    await clinicSignupApi(payload);
  };

  useEffect(() => {
    const handleClinicData = async () => {
      if (clinicData?.isLoading) {
        setLoad(true);
      } else if (!clinicData?.isLoading && clinicData?.isSuccess) {
        const token = clinicData?.data?.token;
        const id = clinicData?.data?.reps;
        setLoad(false);
        Cookies.set("token", token);
        Cookies.set("isReps", id);
        dispatch(setToken(token));
        await dispatch(userData({ token }));

        if (clinicData?.data?.isVerifiedAccount === false) {
          handleRouting("/provider/two-factor-verification")
        } else {
          if (
            clinicData?.data?.isAccountData === false &&
            clinicData?.data?.type === "physician"
          ) {
            handleRouting("/provider/profile-setting")
          } else {
            setError("account already setup please login")
            // toast.error("account already setup please login",)
          }
        }
        toast.success("Verify your email");
      } else if (
        clinicData?.isError &&
        clinicData?.status === "rejected" &&
        clinicData?.error?.status === 400
      ) {
        if (clinicData?.error?.data?.message === "NPI number is not valid") {
          setNpmErrorClinic({
            error: clinicData?.error?.data?.message,
          });
        } else {
          setError(clinicData?.error?.data.message)
          // toast.error(clinicData?.error?.data.message);
        }
        setLoad(false);
      }
    };

    handleClinicData();
  }, [clinicData, dispatch, router]);
  
  const handleNavigation = (href) => {
    setIsNavigating(true);
    setTimeout(() => {
      router.push(href);
    }, 100);
  };
  
  useEffect(() => {
    const originalPushState = window.history.pushState;
    window.history.pushState = function() {
      originalPushState.apply(this, arguments);
      setTimeout(() => {
        setIsNavigating(false);
        setLoading(false);
        setIsResetting(false);
      }, 300);
    };
    return () => {
      window.history.pushState = originalPushState;
    };
  }, []);
  
  const handleReset = (e) => {
    e.preventDefault();
    setIsResetting(true);
    
    // Reset form fields
    setSignup({
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
      npi_number: null,
    });
    
    // Reset form validation
    reset();
    setError("");
    setNpmErrorPhysician(undefined);
    
    // Simulate loading delay
    setTimeout(() => {
      setIsResetting(false);
    }, 500);
  };
  
  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };
  return (
    <>
      {isNavigating && <Loader />}
      <div className="flex flex-row h-screen ">
      <div className="w-[50%] hidden lg:block sign-up-bg overflow-hidden">
          <div className="h-screen px-8 xl:px-20 py-10 flex items-center justify-between flex-col">
            <div className="flex-1 flex items-center">
              <div className="self-stretch flex-col justify-center mx-auto items-start gap-6 inline-flex">
                <div className="self-stretch flex-col flex justify-center text-neutral-50 text-5xl font-semibold font-poppins leading-[58px]">
                  <span>Empowering</span>
                  <span>Physicians, </span>
                  <span>Advancing Healthcare</span>
                </div>
                <div className="self-stretch max-w-[450px] p-0.5 opacity-95 justify-start items-start gap-2.5 inline-flex">
                  <div className="grow shrink basis-0 text-zinc-200 text-lg font-light font-poppins leading-[27px]">
                    Harnessing Cutting-Edge Technology for Better Patient Outcomes
                  </div>
                </div>
              </div>
            </div>
            <div className="self-stretch flex-col justify-start items-center gap-5 inline-flex pb-6">
              <div className="pl-[25px] pr-[26px] pt-[26px] pb-[42px] bg-white bg-opacity-10 rounded-2xl border border-white border-opacity-50 backdrop-blur-[12px] justify-center items-center inline-flex">
                <div className="self-stretch flex-col justify-start items-start gap-[22px] inline-flex">
                  <div className="max-w-[508px] p-0.5 justify-start items-start gap-2.5 inline-flex">
                    <div className="grow shrink basis-0 text-gray-100 text-base font-light font-poppins leading-normal">
                      Alpha.MD has saved me a tremendous amount of time.
                      Instead of spending hours researching medications on my
                      own, I can quickly see how my peers are actually using
                      and experiencing different treatments through their
                      reviews. These real-world insights from other physicians
                      have been incredibly valuable. I highly recommend it.
                    </div>
                  </div>
                  <div className="justify-start items-center gap-2.5 inline-flex">
                    <Image src={"/Images/doctor.png"} alt="doc" width={50} height={50} />
                    <div className="w-[108px] flex-col justify-start items-start gap-0.5 inline-flex">
                      <div className="self-stretch text-neutral-100 text-base font-semibold font-poppins">
                        Daphne Park
                      </div>
                      <div className="self-stretch text-white text-opacity-80 text-sm font-light font-poppins">
                        Physician
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-[50%] lg:h-screen flex justify-center items-start pt-4 sm:pt-10 overflow-y-auto">
          <div className="bg-white w-full flex-col px-4 sm:px-10 pb-10 justify-start items-start inline-flex">
            <div>
              <Image src={"/Images/AlphaMdLogo.png"} height={30} width={154}  alt="" />
              <p className="text-[#7C7C8D] text-[8px] font-semibold tracking-[0.15em] mt-1.5">EVIDENCE &bull; EXPERIENCE &bull; OUTCOMES</p>
              <div className="flex items-center gap-2">
                <span className="text-[#7C7C8D] text-[8px] font-semibold tracking-[0.15em] relative -top-[2px]">INTELLIGENCE BY</span>
                <Image src="/Images/website/mdReviewer.svg" width={80} height={16} alt="MDReviewer" className="h-[44px] w-auto object-contain" />
              </div>
            </div>
            <div className="flex-col w-full justify-start pt-4 sm:pt-6 items-start gap-4 sm:gap-8 inline-flex">
              <div className="flex-col w-full justify-center items-start gap-2 flex">
                <div className="text-stone-900 text-2xl sm:text-[32px] font-semibold font-poppins">
                  Create an account
                </div>
                <div className="mt-1 sm:mt-2 w-full text-neutral-400 text-xs sm:text-sm font-medium font-poppins">
                  Fill in your details and start using Alpha.MD instantly
                </div>
              </div>
            </div>
            <div className="flex-col w-full justify-start items-start gap-4 sm:gap-8 pt-4 sm:pt-6 inline-flex">
              <div className="flex-col w-full justify-start items-start gap-4 sm:gap-8 flex">
                <div className="flex-col w-full justify-center items-start gap-2 flex">
                  <div className="self-stretch text-neutral-400 text-xs sm:text-sm font-medium font-poppins">
                    Choose your account type
                  </div>
                  <div className="self-stretch w-full justify-start items-start gap-3 sm:gap-10 flex flex-col lg:flex-row">
                    <div
                      className={`flex items-center w-full lg:w-[50%] cursor-pointer py-3 px-4 border flex-1 rounded-[10px] ${activeTab === 1
                        ? "bg-blue-600 bg-opacity-10 border-blue-600 text-blue-600"
                        : "border-stone-300 text-neutral-600"
                        }`}
                      onClick={() => handleTabClick(1)}
                    >
                      <div className="self-stretch justify-start items-center gap-4 inline-flex">
                        <div className="w-6 h-6 relative">
                          <div className="w-[19.40px] h-[21.60px] ">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M18.1216 13.7103C18.327 14.1845 18.4466 14.7648 18.473 15.4359C19.1663 15.5947 19.6852 16.2149 19.6852 16.9555C19.6852 17.8157 18.9854 18.5155 18.1252 18.5155C17.265 18.5155 16.5652 17.8157 16.5652 16.9555C16.5652 16.2233 17.0728 15.6096 17.7539 15.4419C17.7239 14.7754 17.5646 13.7614 16.9122 13.2607C16.5794 13.1746 16.2371 13.1122 15.886 13.08C15.8601 14.2476 12.0009 17.1291 12.0009 17.1291C12.0009 17.1291 8.14049 14.2481 8.11433 13.0805C7.72433 13.116 7.34489 13.1873 6.97841 13.29C6.50249 13.6668 6.25625 14.3688 6.24353 15.3893C6.38345 15.4697 6.49649 15.5952 6.56585 15.7471C7.07849 15.9893 7.53137 16.4986 7.87817 17.2236C7.93625 17.3455 7.94393 17.4833 7.90121 17.6091C8.10905 18.144 8.22785 18.7287 8.22785 19.2197C8.22785 19.9078 8.22785 20.5584 7.47785 20.7255C7.39673 20.7929 7.29497 20.8301 7.18817 20.8301H6.68705C6.43577 20.8301 6.23129 20.6251 6.23129 20.3746L6.23177 20.3568C6.24137 20.1144 6.44417 19.9188 6.68705 19.9188H7.18817C7.23953 19.9188 7.28969 19.9275 7.33817 19.9443C7.36841 19.9359 7.37801 19.9289 7.37825 19.9287C7.43393 19.8298 7.43393 19.4179 7.43393 19.2202C7.43393 18.8213 7.33409 18.3396 7.15913 17.892C7.06841 17.8404 6.99497 17.7624 6.94985 17.6681C6.64601 17.0319 6.23273 16.621 5.89721 16.621C5.55401 16.621 5.12009 17.0655 4.81745 17.7259C4.76801 17.8337 4.68137 17.9213 4.57481 17.9739C4.41665 18.402 4.32977 18.8429 4.32977 19.2199C4.32977 19.386 4.32977 19.8267 4.39313 19.9303C4.39385 19.9303 4.40801 19.939 4.44785 19.9488C4.49969 19.9289 4.55537 19.9186 4.61105 19.9186H5.11313C5.34713 19.9186 5.54273 20.0967 5.56625 20.3283L5.56865 20.3563C5.56865 20.6254 5.36417 20.8303 5.11313 20.8303H4.61105C4.51145 20.8303 4.41521 20.797 4.33601 20.7365C4.04921 20.6825 3.84713 20.556 3.71921 20.3501C3.56417 20.1012 3.53585 19.7743 3.53585 19.2199C3.53585 18.7337 3.64817 18.1735 3.85217 17.6386C3.82217 17.5241 3.83225 17.4046 3.88217 17.2968C4.09457 16.8322 4.36481 16.4343 4.66337 16.1465C4.82753 15.9883 5.00393 15.8611 5.18849 15.7683C5.25761 15.6065 5.37761 15.4738 5.52425 15.39C5.53193 14.7504 5.63033 14.1982 5.81225 13.7429C3.72953 14.7994 2.30225 16.9601 2.30225 19.4554C2.30225 22.644 4.63193 22.8 7.68161 22.8C8.01449 22.8 8.35529 22.7981 8.70353 22.7981H15.2956C15.6434 22.7981 15.9842 22.8 16.317 22.8C19.3672 22.8 21.6978 22.644 21.6978 19.4554C21.6976 16.9337 20.2398 14.754 18.1216 13.7103Z"
                                fill={activeTab === 1 ? "#354EF0" : "#8E8E8E"}
                              />
                              <path
                                d="M12.0019 13.9181C14.9501 13.9181 17.3398 9.48505 17.3398 6.53713C17.3398 3.58969 14.9501 1.20001 12.0019 1.20001C9.05423 1.20001 6.66455 3.58969 6.66455 6.53713C6.66455 9.48505 9.05423 13.9181 12.0019 13.9181Z"
                                fill={activeTab === 1 ? "#354EF0" : "#8E8E8E"}
                              />
                              <path
                                d="M18.125 17.6755C18.5227 17.6755 18.845 17.3532 18.845 16.9555C18.845 16.5579 18.5227 16.2355 18.125 16.2355C17.7274 16.2355 17.405 16.5579 17.405 16.9555C17.405 17.3532 17.7274 17.6755 18.125 17.6755Z"
                                fill={activeTab === 1 ? "#354EF0" : "#8E8E8E"}
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          className={
                            activeTab === 1
                              ? "text-blue-600 text-[14px] font-medium  font-poppins"
                              : "text-neutral-600 text-[14px] font-medium  font-poppins"
                          }
                        >
                          Physician/ Healthcare Provider
                        </div>
                      </div>
                    </div>
                    <div
                      className={`flex items-center w-full lg:w-[50%] cursor-pointer py-3 px-4 border flex-1 rounded-[10px] ${activeTab === 2
                        ? "bg-blue-600 bg-opacity-10 border-blue-600 text-blue-600"
                        : "border-stone-300 text-neutral-600"
                        }`}
                      onClick={() => handleTabClick(2)}
                    >
                      <div className="self-stretch justify-start items-center gap-4 inline-flex">
                        <div className="w-6 h-6 relative">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M22.6571 18.459C22.6853 18.3746 22.7013 18.2842 22.7013 18.1903V8.32235C22.7013 7.85457 22.3219 7.47541 21.8541 7.47541H17.1389V17.9787C17.1389 18.1474 17.1084 18.3086 17.0546 18.459H16.5015C16.5297 18.3746 16.5457 18.2842 16.5457 18.1903V4.63747C16.5457 4.16968 16.1663 3.79053 15.6985 3.79053H8.30102C7.83324 3.79053 7.45408 4.16968 7.45408 4.63747V18.1903C7.45408 18.2842 7.47008 18.3746 7.49827 18.459H6.94541C6.89157 18.3086 6.8611 18.1474 6.8611 17.9787V7.47541H2.25893C1.79114 7.47541 1.41199 7.85457 1.41199 8.32235V18.1903C1.41199 18.2842 1.42799 18.3746 1.45592 18.459H0V20.2097H24V18.459H22.6571ZM3.95281 14.9996H2.73865V13.7857H3.95281V14.9996ZM3.95281 12.8681H2.73865V11.654H3.95281V12.8681ZM3.95281 10.807H2.73865V9.59289H3.95281V10.807ZM5.84477 14.9996H4.63061V13.7857H5.84477V14.9996ZM5.84477 12.8681H4.63061V11.654H5.84477V12.8681ZM5.84477 10.807H4.63061V9.59289H5.84477V10.807ZM13.8847 18.4023H10.32V13.9551H13.8847V18.4023ZM11.9999 10.1432C10.3509 10.1432 9.01413 8.80639 9.01413 7.15746C9.01413 5.50828 10.3512 4.17146 11.9999 4.17146C13.6491 4.17146 14.9859 5.50828 14.9859 7.15746C14.9859 8.80664 13.6491 10.1432 11.9999 10.1432ZM19.7082 14.9996H18.4943V13.7857H19.7082V14.9996ZM19.7082 12.8681H18.4943V11.654H19.7082V12.8681ZM19.7082 10.807H18.4943V9.59289H19.7082V10.807ZM21.5999 14.9996H20.386V13.7857H21.5999V14.9996ZM21.5999 12.8681H20.386V11.654H21.5999V12.8681ZM21.5999 10.807H20.386V9.59289H21.5999V10.807ZM12.7409 6.41642H13.8845V7.8985H12.7409V9.04257H11.2588V7.8985H10.1153V6.41642H11.2588V5.27286H12.7409V6.41642Z"
                              fill={activeTab === 2 ? "#354EF0" : "#8E8E8E"}
                            />
                          </svg>
                        </div>
                        <div
                          className={
                            activeTab === 2
                              ? "text-blue-600 text-[14px] font-medium  font-poppins"
                              : "text-neutral-600 text-[14px] font-medium  font-poppins"
                          }
                        >
                          Clinic/ Office /Hospital
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {error && <div className="text-sm mt-3 w-full bg-red-500/10 text-red-600 px-3 py-2 rounded-lg">
              {error}
            </div>}
            {activeTab === 1 && (
              <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
                <div className="w-full">
                  <div className="w-full pt-3 sm:pt-4 gap-3 sm:gap-8 flex flex-col lg:flex-row">
                    <div className="w-full lg:w-[47%] self-stretch pt-0.5 flex-col justify-center items-start gap-[9px] inline-flex">
                      <div className="w-full text-neutral-400 text-xs sm:text-sm font-medium font-poppins">
                        First Name
                      </div>
                      <div
                        className={`${errors.firstName
                          ? "border border-[#DD4243]"
                          : "border-blue-600"
                          } self-stretch w-full h-12 pl-[13px] py-3 rounded-[10px] border justify-start items-start  inline-flex`}
                      >
                        <div className="w-6 h-6 relative flex-col justify-start items-start flex">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M11.829 11.5609C13.4172 11.5609 14.7923 10.9913 15.9162 9.86735C17.0398 8.74364 17.6096 7.3687 17.6096 5.78026C17.6096 4.19237 17.04 2.81726 15.9161 1.69317C14.7922 0.56964 13.417 0 11.829 0C10.2405 0 8.8656 0.56964 7.74188 1.69336C6.61816 2.81707 6.04834 4.19219 6.04834 5.78026C6.04834 7.3687 6.61816 8.74382 7.74188 9.86753C8.86596 10.9911 10.2411 11.5609 11.829 11.5609ZM8.73651 2.6878C9.59875 1.82556 10.6102 1.40643 11.829 1.40643C13.0475 1.40643 14.0592 1.82556 14.9216 2.6878C15.7839 3.55023 16.2032 4.56188 16.2032 5.78026C16.2032 6.99901 15.7839 8.01048 14.9216 8.87291C14.0592 9.73533 13.0475 10.1545 11.829 10.1545C10.6106 10.1545 9.59911 9.73515 8.73651 8.87291C7.87408 8.01067 7.45477 6.99901 7.45477 5.78026C7.45477 4.56188 7.87408 3.55023 8.73651 2.6878Z"
                              fill="#4B4B4B"
                            />
                            <path
                              d="M21.9435 18.4548C21.9111 17.9872 21.8455 17.477 21.749 16.9383C21.6516 16.3956 21.5262 15.8825 21.3761 15.4136C21.2208 14.9289 21.01 14.4503 20.7491 13.9916C20.4787 13.5155 20.1608 13.101 19.8041 12.7599C19.4311 12.403 18.9745 12.1161 18.4464 11.9068C17.9201 11.6986 17.3369 11.5931 16.7131 11.5931C16.4681 11.5931 16.2312 11.6936 15.7736 11.9916C15.492 12.1752 15.1626 12.3876 14.7949 12.6225C14.4805 12.8229 14.0546 13.0105 13.5285 13.1805C13.0153 13.3465 12.4942 13.4308 11.9797 13.4308C11.4655 13.4308 10.9444 13.3465 10.4308 13.1805C9.90526 13.0107 9.47917 12.823 9.16533 12.6227C8.80113 12.39 8.47155 12.1776 8.18572 11.9914C7.7285 11.6935 7.49157 11.5929 7.24657 11.5929C6.62255 11.5929 6.03954 11.6986 5.51348 11.907C4.98577 12.1159 4.52893 12.4028 4.15557 12.7601C3.79889 13.1014 3.48102 13.5157 3.21075 13.9916C2.95019 14.4503 2.73926 14.9288 2.58398 15.4138C2.43402 15.8827 2.30859 16.3956 2.21118 16.9383C2.1145 17.4763 2.04913 17.9866 2.01672 18.4554C1.98486 18.9137 1.96875 19.3907 1.96875 19.8726C1.96875 21.1254 2.367 22.1396 3.15234 22.8876C3.92797 23.6257 4.9541 24 6.20232 24H17.7585C19.0063 24 20.0324 23.6257 20.8083 22.8876C21.5938 22.1402 21.992 21.1256 21.992 19.8724C21.9918 19.3888 21.9755 18.9118 21.9435 18.4548ZM19.8385 21.8686C19.326 22.3564 18.6456 22.5935 17.7583 22.5935H6.20232C5.31481 22.5935 4.63439 22.3564 4.12207 21.8688C3.61944 21.3903 3.37518 20.7372 3.37518 19.8726C3.37518 19.4229 3.39001 18.9789 3.41967 18.5526C3.44861 18.1344 3.50775 17.675 3.59546 17.1868C3.68206 16.7047 3.79229 16.2522 3.9234 15.8426C4.04919 15.4499 4.22076 15.061 4.43353 14.6863C4.63659 14.3293 4.87023 14.0229 5.12805 13.7761C5.3692 13.5452 5.67315 13.3562 6.0313 13.2145C6.36254 13.0834 6.73479 13.0116 7.13891 13.0008C7.18816 13.027 7.27587 13.077 7.41796 13.1697C7.70708 13.3581 8.04033 13.573 8.40874 13.8083C8.82402 14.0731 9.35906 14.3122 9.99828 14.5186C10.6518 14.7299 11.3183 14.8372 11.9798 14.8372C12.6414 14.8372 13.3081 14.7299 13.9612 14.5188C14.601 14.3121 15.1358 14.0731 15.5517 13.808C15.9287 13.567 16.2526 13.3583 16.5417 13.1697C16.6838 13.0772 16.7715 13.027 16.8208 13.0008C17.2251 13.0116 17.5973 13.0834 17.9287 13.2145C18.2867 13.3562 18.5907 13.5454 18.8318 13.7761C19.0896 14.0227 19.3233 14.3291 19.5263 14.6865C19.7393 15.061 19.911 15.4501 20.0366 15.8424C20.1679 16.2526 20.2783 16.7049 20.3648 17.1866C20.4523 17.6757 20.5116 18.1353 20.5406 18.5528V18.5531C20.5704 18.9778 20.5854 19.4216 20.5856 19.8726C20.5854 20.7374 20.3412 21.3903 19.8385 21.8686Z"
                              fill="#4B4B4B"
                            />
                          </svg>
                        </div>
                        <input
                          {...register("firstName", {
                            required: "first name is required",
                          })}
                          onChange={onChangeHandler}
                          type="text"
                          name="firstName"
                          value={signup.firstName}
                          placeholder="Your first name"
                          className=" outline-none px-2 border-none w-full"
                        />
                      </div>
                      {errors.firstName ? (
                        <div className="w-full text-red-500 text-xs sm:text-sm">
                          {errors.firstName.message}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="w-full lg:w-[47%] self-stretch pt-0.5 flex-col justify-center items-start gap-[9px] inline-flex">
                      <div className="w-full text-neutral-400 text-xs sm:text-sm font-medium font-poppins">
                        Last Name
                      </div>
                      <div
                        className={`${errors.lastName
                          ? "border border-[#DD4243]"
                          : "border-blue-600"
                          } self-stretch w-full h-12 pl-[13px]  py-3 rounded-[10px] border  justify-start items-start inline-flex`}
                      >
                        <div className="w-6 h-6 relative flex-col justify-start items-start flex">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M11.829 11.5609C13.4172 11.5609 14.7923 10.9913 15.9162 9.86735C17.0398 8.74364 17.6096 7.3687 17.6096 5.78026C17.6096 4.19237 17.04 2.81726 15.9161 1.69317C14.7922 0.56964 13.417 0 11.829 0C10.2405 0 8.8656 0.56964 7.74188 1.69336C6.61816 2.81707 6.04834 4.19219 6.04834 5.78026C6.04834 7.3687 6.61816 8.74382 7.74188 9.86753C8.86596 10.9911 10.2411 11.5609 11.829 11.5609ZM8.73651 2.6878C9.59875 1.82556 10.6102 1.40643 11.829 1.40643C13.0475 1.40643 14.0592 1.82556 14.9216 2.6878C15.7839 3.55023 16.2032 4.56188 16.2032 5.78026C16.2032 6.99901 15.7839 8.01048 14.9216 8.87291C14.0592 9.73533 13.0475 10.1545 11.829 10.1545C10.6106 10.1545 9.59911 9.73515 8.73651 8.87291C7.87408 8.01067 7.45477 6.99901 7.45477 5.78026C7.45477 4.56188 7.87408 3.55023 8.73651 2.6878Z"
                              fill="#4B4B4B"
                            />
                            <path
                              d="M21.9435 18.4548C21.9111 17.9872 21.8455 17.477 21.749 16.9383C21.6516 16.3956 21.5262 15.8825 21.3761 15.4136C21.2208 14.9289 21.01 14.4503 20.7491 13.9916C20.4787 13.5155 20.1608 13.101 19.8041 12.7599C19.4311 12.403 18.9745 12.1161 18.4464 11.9068C17.9201 11.6986 17.3369 11.5931 16.7131 11.5931C16.4681 11.5931 16.2312 11.6936 15.7736 11.9916C15.492 12.1752 15.1626 12.3876 14.7949 12.6225C14.4805 12.8229 14.0546 13.0105 13.5285 13.1805C13.0153 13.3465 12.4942 13.4308 11.9797 13.4308C11.4655 13.4308 10.9444 13.3465 10.4308 13.1805C9.90526 13.0107 9.47917 12.823 9.16533 12.6227C8.80113 12.39 8.47155 12.1776 8.18572 11.9914C7.7285 11.6935 7.49157 11.5929 7.24657 11.5929C6.62255 11.5929 6.03954 11.6986 5.51348 11.907C4.98577 12.1159 4.52893 12.4028 4.15557 12.7601C3.79889 13.1014 3.48102 13.5157 3.21075 13.9916C2.95019 14.4503 2.73926 14.9288 2.58398 15.4138C2.43402 15.8827 2.30859 16.3956 2.21118 16.9383C2.1145 17.4763 2.04913 17.9866 2.01672 18.4554C1.98486 18.9137 1.96875 19.3907 1.96875 19.8726C1.96875 21.1254 2.367 22.1396 3.15234 22.8876C3.92797 23.6257 4.9541 24 6.20232 24H17.7585C19.0063 24 20.0324 23.6257 20.8083 22.8876C21.5938 22.1402 21.992 21.1256 21.992 19.8724C21.9918 19.3888 21.9755 18.9118 21.9435 18.4548ZM19.8385 21.8686C19.326 22.3564 18.6456 22.5935 17.7583 22.5935H6.20232C5.31481 22.5935 4.63439 22.3564 4.12207 21.8688C3.61944 21.3903 3.37518 20.7372 3.37518 19.8726C3.37518 19.4229 3.39001 18.9789 3.41967 18.5526C3.44861 18.1344 3.50775 17.675 3.59546 17.1868C3.68206 16.7047 3.79229 16.2522 3.9234 15.8426C4.04919 15.4499 4.22076 15.061 4.43353 14.6863C4.63659 14.3293 4.87023 14.0229 5.12805 13.7761C5.3692 13.5452 5.67315 13.3562 6.0313 13.2145C6.36254 13.0834 6.73479 13.0116 7.13891 13.0008C7.18816 13.027 7.27587 13.077 7.41796 13.1697C7.70708 13.3581 8.04033 13.573 8.40874 13.8083C8.82402 14.0731 9.35906 14.3122 9.99828 14.5186C10.6518 14.7299 11.3183 14.8372 11.9798 14.8372C12.6414 14.8372 13.3081 14.7299 13.9612 14.5188C14.601 14.3121 15.1358 14.0731 15.5517 13.808C15.9287 13.567 16.2526 13.3583 16.5417 13.1697C16.6838 13.0772 16.7715 13.027 16.8208 13.0008C17.2251 13.0116 17.5973 13.0834 17.9287 13.2145C18.2867 13.3562 18.5907 13.5454 18.8318 13.7761C19.0896 14.0227 19.3233 14.3291 19.5263 14.6865C19.7393 15.061 19.911 15.4501 20.0366 15.8424C20.1679 16.2526 20.2783 16.7049 20.3648 17.1866C20.4523 17.6757 20.5116 18.1353 20.5406 18.5528V18.5531C20.5704 18.9778 20.5854 19.4216 20.5856 19.8726C20.5854 20.7374 20.3412 21.3903 19.8385 21.8686Z"
                              fill="#4B4B4B"
                            />
                          </svg>
                        </div>
                        <input
                          {...register("lastName", {
                            required: "last name is required",
                          })}
                          onChange={onChangeHandler}
                          type="text"
                          name="lastName"
                          value={signup.lastName}
                          placeholder="Your last name"
                          className=" outline-none px-2 border-none w-full"
                        />
                      </div>
                      {errors.lastName ? (
                        <div className="w-full text-red-500 text-xs sm:text-sm">
                          {errors.lastName.message}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="self-stretch pt-3 sm:pt-4 flex-col justify-start items-start gap-2 flex">
                    <div className="w-full text-neutral-400 text-xs sm:text-sm font-medium font-poppins">
                      Email
                    </div>
                    <div
                      className={`${errors.email
                        ? "border border-[#DD4243]"
                        : "border-blue-600"
                        }
w-full h-12 pl-3  py-3 rounded-[10px] border  justify-start items-start  inline-flex`}
                    >
                      <div className="w-6 h-6 relative flex-col justify-start items-start flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M21.6974 15.8335C21.6974 17.8602 20.0488 19.5062 18.0247 19.5062H5.97513C3.95102 19.5062 2.30238 17.8601 2.30238 15.8335V8.16651C2.30238 7.49011 2.48758 6.85481 2.80905 6.30956L8.68849 12.189C9.5681 13.0712 10.746 13.5573 12.0011 13.5573C13.2537 13.5573 14.4316 13.0712 15.3112 12.189L21.1907 6.30956C21.5122 6.85481 21.6973 7.49006 21.6973 8.16651V15.8335H21.6974ZM18.0246 4.49381H5.97513C5.13925 4.49381 4.36764 4.7767 3.75039 5.24737L9.68899 11.1885C10.3037 11.8006 11.1241 12.1402 12.0011 12.1402C12.8756 12.1402 13.6961 11.8006 14.3107 11.1885L20.2493 5.24737C19.6321 4.7767 18.8606 4.49381 18.0246 4.49381ZM18.0246 3.07669H5.97513C3.16914 3.07669 0.885254 5.36058 0.885254 8.16656V15.8335C0.885254 18.6421 3.16914 20.9234 5.97513 20.9234H18.0246C20.8306 20.9234 23.1145 18.6421 23.1145 15.8335V8.16651C23.1145 5.36053 20.8306 3.07669 18.0246 3.07669Z"
                            fill="#4B4B4B"
                          />
                        </svg>
                      </div>
                      <input
                        {...register("email", {
                          required: "email is required",
                          pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "Invalid email address",
                          },
                        })}
                        onChange={onChangeHandler}
                        type="email"
                        name="email"
                        value={signup.email}
                        placeholder="Someone@example.com"
                        className=" outline-none px-2 border-none w-full"
                      />
                    </div>
                    {errors.email ? (
                      <div className="w-full text-red-500 text-xs sm:text-sm">
                        {errors.email.message}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="w-full pt-3 sm:pt-4 gap-3 sm:gap-8 flex flex-col lg:flex-row">
                    <div className="w-full lg:w-[47%] self-stretch pt-0.5 flex-col justify-center items-start gap-[9px] inline-flex">
                      <div className="w-full text-neutral-400 text-xs sm:text-sm font-medium font-poppins">
                        Password
                      </div>
                      <div
                        className={`${errors.password
                          ? "border border-[#DD4243]"
                          : "border-blue-600"
                          } self-stretch h-12 px-2 py-3 w-full rounded-[10px] border justify-between items-start  inline-flex`}
                      >
                        <input
                          {...register("password", {
                            required: "Password is required",
                            pattern: {
                              value:
                                /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
                              message:
                                "Password must include at least one letter, one number, and one special character, and be at least 6 characters long",
                            },
                          })}
                          name="password"
                          placeholder="Enter Password"
                          value={signup.password}
                          onChange={onChangeHandler}
                          type={isPasswordVisible ? "text" : "password"}
                          className=" border-none outline-none w-full px-2"
                        />
                        <div
                          onClick={togglePasswordVisibility}
                          className="cursor-pointer"
                        >
                          {isPasswordVisible ? (
                            <Image src={"/Images/view.svg"} height={24} width={24}   alt="" />
                          ) : (
                            <Image src={"/Images/Hide.svg"} height={24} width={24}   alt="" />
                          )}
                        </div>
                      </div>

                      {errors.password ? (
                        <div className="w-full text-red-500 text-xs sm:text-sm">
                          {errors.password.message}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="w-full lg:w-[47%] self-stretch pt-0.5 flex-col justify-center items-start gap-[9px] inline-flex">
                      <div className="w-full text-neutral-400 text-xs sm:text-sm font-medium font-poppins">
                        Confirm Password
                      </div>
                      <div
                        className={`${errors?.confirmPassword?.message ===
                          "confirm password is required" ||
                          errors?.confirmPassword?.message ===
                          "password do not match with confirm password"
                          ? " border-[#DD4243]"
                          : "border-blue-600"
                          }  self-stretch h-12 px-2  py-3 rounded-[10px] border  justify-between w-full items-start inline-flex `}
                      >
                        <input
                          {...register("confirmPassword", {
                            required: "confirm password is required",
                            validate: (value) =>
                              value === signup?.password ||
                              "password do not match with confirm password",
                          })}
                          name="confirmPassword"
                          value={signup?.confirmPassword}
                          onChange={onChangeHandler}
                          type={"password"}
                          placeholder="Enter confirm password"
                          className="w-full border-none outline-none px-2"
                        />
                        {/* <div
                          onClick={togglePasswordVisibility}
                          className="cursor-pointer"
                        >
                          {isPasswordVisible ? (
                            <Image src={ShowEye}  alt="" />
                          ) : (
                            <Image src={CloseEye}  alt="" />
                          )}
                        </div> */}
                      </div>
                      {errors?.confirmPassword?.message ===
                        "confirm password is required" ? (
                        <div className="w-full text-red-500 text-xs sm:text-sm mt-2">
                          {errors?.confirmPassword?.message}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {errors?.confirmPassword?.message ===
                    "password do not match with confirm password" ? (
                    <div className="w-full text-red-500 text-xs sm:text-sm">
                      {errors.confirmPassword.message}
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="self-stretch pt-3 sm:pt-4 flex-col justify-start items-start gap-2 flex">
                    <div className="w-full text-neutral-400 text-xs sm:text-sm font-medium font-poppins">
                      NPI Number (Optional)
                    </div>
                    <div
                      className={`${npmErrorPhysician?.error || errors?.npi_number?.message
                        ? "border-[#DD4243] "
                        : "border-blue-600"
                        } w-full h-12 pl-3  py-3 rounded-[10px] border justify-start items-start  inline-flex`}
                    >
                      <div className="w-6 h-6 relative flex-col justify-start items-start flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M4.16446 16.3489C3.97246 16.3489 3.78083 16.2757 3.63421 16.1291C3.34133 15.8362 3.34133 15.3615 3.63421 15.0686L15.3545 3.34837C15.647 3.0555 16.1221 3.0555 16.415 3.34837C16.7078 3.64125 16.7078 4.116 16.415 4.40887L4.69471 16.1291C4.54846 16.2754 4.35646 16.3489 4.16446 16.3489Z"
                            fill="#4B4B4B"
                          />
                          <path
                            d="M3.00636 21.75C2.95424 21.75 2.90136 21.7444 2.84849 21.7331C2.44349 21.6461 2.18549 21.2475 2.27249 20.8425L3.43124 15.4414C3.51824 15.0364 3.91874 14.7791 4.32186 14.8654C4.72686 14.9524 4.98486 15.351 4.89786 15.756L3.73911 21.1571C3.66374 21.5093 3.35249 21.75 3.00636 21.75Z"
                            fill="#4B4B4B"
                          />
                          <path
                            d="M8.40664 20.5912C8.21464 20.5912 8.02302 20.5181 7.87639 20.3715C7.58352 20.0786 7.58352 19.6039 7.87639 19.311L19.5966 7.59112C19.8891 7.29825 20.3643 7.29825 20.6571 7.59112C20.95 7.884 20.95 8.35875 20.6571 8.65162L8.93727 20.3715C8.79064 20.5181 8.59864 20.5912 8.40664 20.5912Z"
                            fill="#4B4B4B"
                          />
                          <path
                            d="M3.00488 21.75C2.65876 21.75 2.34788 21.5092 2.27213 21.1571C2.18551 20.7521 2.44313 20.3535 2.84813 20.2665L8.24926 19.1077C8.65463 19.0219 9.05326 19.2791 9.13988 19.6838C9.22651 20.0888 8.96888 20.4874 8.56388 20.5744L3.16276 21.7331C3.10988 21.7448 3.05701 21.75 3.00488 21.75Z"
                            fill="#4B4B4B"
                          />
                          <path
                            d="M18.0057 10.9924C17.8137 10.9924 17.6217 10.9192 17.4755 10.7726L13.2331 6.53025C12.9402 6.23737 12.9402 5.76262 13.2331 5.46975C13.5256 5.17687 14.0011 5.17687 14.2936 5.46975L18.536 9.71212C18.8288 10.005 18.8288 10.4797 18.536 10.7726C18.3897 10.9192 18.1977 10.9924 18.0057 10.9924Z"
                            fill="#4B4B4B"
                          />
                          <path
                            d="M20.1271 8.87138C19.9351 8.87138 19.7431 8.79825 19.5964 8.65163C19.3036 8.35875 19.3036 7.884 19.5964 7.59075C20.0138 7.17338 20.2437 6.60825 20.2437 6C20.2437 5.39175 20.0138 4.82663 19.5964 4.40925C19.1787 3.9915 18.6136 3.76163 18.0053 3.76163C17.3971 3.76163 16.8319 3.9915 16.4146 4.40925C16.1221 4.70213 15.6473 4.7025 15.3537 4.40925C15.0608 4.11638 15.0608 3.64163 15.3537 3.34838C16.0542 2.6475 16.9958 2.26163 18.0053 2.26163C19.0144 2.26163 19.9564 2.6475 20.6569 3.34838C21.3578 4.04888 21.7437 4.9905 21.7437 6C21.7437 7.0095 21.3578 7.95113 20.6569 8.65163C20.5111 8.79788 20.3191 8.87138 20.1271 8.87138Z"
                            fill="#4B4B4B"
                          />
                        </svg>
                      </div>
                      <input
                        {...register("npi_number", {
                          pattern: {
                            value: /^\d{10}$/,
                            message: "NPI number should be 10 digits!",
                          },
                        })}
                        onChange={onChangeHandler}
                        type="number"
                        name="npi_number"
                        value={signup.npi_number}
                        placeholder="Your NPI number"
                        className=" outline-none px-2 border-none w-full"
                      />
                    </div>
                    {errors?.npi_number?.message ? (
                      <div className="w-full text-red-500 text-xs sm:text-sm">
                        {errors?.npi_number?.message}
                      </div>
                    ) : (
                      ""
                    )}
                    {npmErrorPhysician?.error ? (
                      <div className="w-full text-red-500 text-xs sm:text-sm">
                        {npmErrorPhysician?.error}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="w-full pt-4 sm:pt-6 justify-center items-start gap-3 sm:gap-8 inline-flex">
                    <div className="w-[50%] cursor-pointer px-4 py-2.5 sm:py-3 rounded-[10px] border border-blue-600 justify-center items-center gap-2.5 inline-flex">
                      <div className="text-blue-600 text-sm sm:text-base font-medium font-poppins">
                        Reset
                      </div>
                    </div>
                    <button className="w-[50%]">
                      <div className="w-full cursor-pointer px-4 py-2.5 sm:py-3 bg-blue-600 rounded-[10px] justify-center items-center gap-2.5 inline-flex">
                        <div className="text-white text-sm sm:text-base font-medium font-poppins">
                          {loading ? "Loading..." : "Sign Up"}
                        </div>
                      </div>
                    </button>
                  </div>
                  <div className="pt-3 pb-4 sm:pb-0">
                    <span className="text-neutral-400 text-xs sm:text-sm font-medium font-poppins">
                      Already have an account?{" "}
                    </span>
                    <Link href="login">
                      <span className="text-blue-600 text-xs sm:text-sm cursor-pointer font-medium font-poppins underline">
                        Log In
                      </span>
                    </Link>
                  </div>
                </div>
              </form>
            )}
            {activeTab === 2 && false && (
              <form className="" onSubmit={handleSubmit(onSubmitClinic)}>
                <div className="self-stretch flex-col  inline-flex">
                  <div className="flex-col justify-start items-start gap-8 flex">
                    <div className="self-stretch py-4  flex-col justify-start items-start gap-4 flex">
                      <div className="w-[644px]  gap-8 inline-flex">
                        <div className="grow shrink basis-0 self-stretch pt-0.5 flex-col justify-center items-start gap-[9px] inline-flex">
                          <div className="w-[306px] text-neutral-400 text-sm font-medium  font-poppins">
                            First Name
                          </div>
                          <div
                            className={`${errors.firstName_cl
                              ? "border border-[#DD4243]"
                              : "border-blue-600"
                              } self-stretch h-12 pl-[13px] py-3 rounded-[10px] border justify-start items-start  inline-flex`}
                          >
                            <div className="w-6 h-6 relative flex-col justify-start items-start flex">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M11.829 11.5609C13.4172 11.5609 14.7923 10.9913 15.9162 9.86735C17.0398 8.74364 17.6096 7.3687 17.6096 5.78026C17.6096 4.19237 17.04 2.81726 15.9161 1.69317C14.7922 0.56964 13.417 0 11.829 0C10.2405 0 8.8656 0.56964 7.74188 1.69336C6.61816 2.81707 6.04834 4.19219 6.04834 5.78026C6.04834 7.3687 6.61816 8.74382 7.74188 9.86753C8.86596 10.9911 10.2411 11.5609 11.829 11.5609ZM8.73651 2.6878C9.59875 1.82556 10.6102 1.40643 11.829 1.40643C13.0475 1.40643 14.0592 1.82556 14.9216 2.6878C15.7839 3.55023 16.2032 4.56188 16.2032 5.78026C16.2032 6.99901 15.7839 8.01048 14.9216 8.87291C14.0592 9.73533 13.0475 10.1545 11.829 10.1545C10.6106 10.1545 9.59911 9.73515 8.73651 8.87291C7.87408 8.01067 7.45477 6.99901 7.45477 5.78026C7.45477 4.56188 7.87408 3.55023 8.73651 2.6878Z"
                                  fill="#4B4B4B"
                                />
                                <path
                                  d="M21.9435 18.4548C21.9111 17.9872 21.8455 17.477 21.749 16.9383C21.6516 16.3956 21.5262 15.8825 21.3761 15.4136C21.2208 14.9289 21.01 14.4503 20.7491 13.9916C20.4787 13.5155 20.1608 13.101 19.8041 12.7599C19.4311 12.403 18.9745 12.1161 18.4464 11.9068C17.9201 11.6986 17.3369 11.5931 16.7131 11.5931C16.4681 11.5931 16.2312 11.6936 15.7736 11.9916C15.492 12.1752 15.1626 12.3876 14.7949 12.6225C14.4805 12.8229 14.0546 13.0105 13.5285 13.1805C13.0153 13.3465 12.4942 13.4308 11.9797 13.4308C11.4655 13.4308 10.9444 13.3465 10.4308 13.1805C9.90526 13.0107 9.47917 12.823 9.16533 12.6227C8.80113 12.39 8.47155 12.1776 8.18572 11.9914C7.7285 11.6935 7.49157 11.5929 7.24657 11.5929C6.62255 11.5929 6.03954 11.6986 5.51348 11.907C4.98577 12.1159 4.52893 12.4028 4.15557 12.7601C3.79889 13.1014 3.48102 13.5157 3.21075 13.9916C2.95019 14.4503 2.73926 14.9288 2.58398 15.4138C2.43402 15.8827 2.30859 16.3956 2.21118 16.9383C2.1145 17.4763 2.04913 17.9866 2.01672 18.4554C1.98486 18.9137 1.96875 19.3907 1.96875 19.8726C1.96875 21.1254 2.367 22.1396 3.15234 22.8876C3.92797 23.6257 4.9541 24 6.20232 24H17.7585C19.0063 24 20.0324 23.6257 20.8083 22.8876C21.5938 22.1402 21.992 21.1256 21.992 19.8724C21.9918 19.3888 21.9755 18.9118 21.9435 18.4548ZM19.8385 21.8686C19.326 22.3564 18.6456 22.5935 17.7583 22.5935H6.20232C5.31481 22.5935 4.63439 22.3564 4.12207 21.8688C3.61944 21.3903 3.37518 20.7372 3.37518 19.8726C3.37518 19.4229 3.39001 18.9789 3.41967 18.5526C3.44861 18.1344 3.50775 17.675 3.59546 17.1868C3.68206 16.7047 3.79229 16.2522 3.9234 15.8426C4.04919 15.4499 4.22076 15.061 4.43353 14.6863C4.63659 14.3293 4.87023 14.0229 5.12805 13.7761C5.3692 13.5452 5.67315 13.3562 6.0313 13.2145C6.36254 13.0834 6.73479 13.0116 7.13891 13.0008C7.18816 13.027 7.27587 13.077 7.41796 13.1697C7.70708 13.3581 8.04033 13.573 8.40874 13.8083C8.82402 14.0731 9.35906 14.3122 9.99828 14.5186C10.6518 14.7299 11.3183 14.8372 11.9798 14.8372C12.6414 14.8372 13.3081 14.7299 13.9612 14.5188C14.601 14.3121 15.1358 14.0731 15.5517 13.808C15.9287 13.567 16.2526 13.3583 16.5417 13.1697C16.6838 13.0772 16.7715 13.027 16.8208 13.0008C17.2251 13.0116 17.5973 13.0834 17.9287 13.2145C18.2867 13.3562 18.5907 13.5454 18.8318 13.7761C19.0896 14.0227 19.3233 14.3291 19.5263 14.6865C19.7393 15.061 19.911 15.4501 20.0366 15.8424C20.1679 16.2526 20.2783 16.7049 20.3648 17.1866C20.4523 17.6757 20.5116 18.1353 20.5406 18.5528V18.5531C20.5704 18.9778 20.5854 19.4216 20.5856 19.8726C20.5854 20.7374 20.3412 21.3903 19.8385 21.8686Z"
                                  fill="#4B4B4B"
                                />
                              </svg>
                            </div>
                            <input
                              {...register("firstName_cl", {
                                required: "first name is required",
                              })}
                              name="firstName_cl"
                              onChange={onChangeHandlerClinic}
                              value={clinicSignup.firstName_cl}
                              placeholder="Your first name"
                              className=" outline-none px-2 border-none w-full"
                            />
                          </div>
                          {errors.firstName_cl ? (
                            <div className="w-[300px] text-red-500 text-sm ">
                              {errors.firstName_cl.message}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="grow shrink basis-0 self-stretch pt-0.5 flex-col justify-center items-start gap-[9px] inline-flex">
                          <div className="w-[306px] text-neutral-400 text-sm font-medium  font-poppins">
                            Last Name
                          </div>
                          <div
                            className={`${errors.lastName_cl
                              ? "border border-[#DD4243]"
                              : "border-blue-600"
                              } self-stretch h-12 pl-[13px]  py-3 rounded-[10px] border  justify-start items-start  inline-flex`}
                          >
                            <div className="w-6 h-6 relative flex-col justify-start items-start flex">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M11.829 11.5609C13.4172 11.5609 14.7923 10.9913 15.9162 9.86735C17.0398 8.74364 17.6096 7.3687 17.6096 5.78026C17.6096 4.19237 17.04 2.81726 15.9161 1.69317C14.7922 0.56964 13.417 0 11.829 0C10.2405 0 8.8656 0.56964 7.74188 1.69336C6.61816 2.81707 6.04834 4.19219 6.04834 5.78026C6.04834 7.3687 6.61816 8.74382 7.74188 9.86753C8.86596 10.9911 10.2411 11.5609 11.829 11.5609ZM8.73651 2.6878C9.59875 1.82556 10.6102 1.40643 11.829 1.40643C13.0475 1.40643 14.0592 1.82556 14.9216 2.6878C15.7839 3.55023 16.2032 4.56188 16.2032 5.78026C16.2032 6.99901 15.7839 8.01048 14.9216 8.87291C14.0592 9.73533 13.0475 10.1545 11.829 10.1545C10.6106 10.1545 9.59911 9.73515 8.73651 8.87291C7.87408 8.01067 7.45477 6.99901 7.45477 5.78026C7.45477 4.56188 7.87408 3.55023 8.73651 2.6878Z"
                                  fill="#4B4B4B"
                                />
                                <path
                                  d="M21.9435 18.4548C21.9111 17.9872 21.8455 17.477 21.749 16.9383C21.6516 16.3956 21.5262 15.8825 21.3761 15.4136C21.2208 14.9289 21.01 14.4503 20.7491 13.9916C20.4787 13.5155 20.1608 13.101 19.8041 12.7599C19.4311 12.403 18.9745 12.1161 18.4464 11.9068C17.9201 11.6986 17.3369 11.5931 16.7131 11.5931C16.4681 11.5931 16.2312 11.6936 15.7736 11.9916C15.492 12.1752 15.1626 12.3876 14.7949 12.6225C14.4805 12.8229 14.0546 13.0105 13.5285 13.1805C13.0153 13.3465 12.4942 13.4308 11.9797 13.4308C11.4655 13.4308 10.9444 13.3465 10.4308 13.1805C9.90526 13.0107 9.47917 12.823 9.16533 12.6227C8.80113 12.39 8.47155 12.1776 8.18572 11.9914C7.7285 11.6935 7.49157 11.5929 7.24657 11.5929C6.62255 11.5929 6.03954 11.6986 5.51348 11.907C4.98577 12.1159 4.52893 12.4028 4.15557 12.7601C3.79889 13.1014 3.48102 13.5157 3.21075 13.9916C2.95019 14.4503 2.73926 14.9288 2.58398 15.4138C2.43402 15.8827 2.30859 16.3956 2.21118 16.9383C2.1145 17.4763 2.04913 17.9866 2.01672 18.4554C1.98486 18.9137 1.96875 19.3907 1.96875 19.8726C1.96875 21.1254 2.367 22.1396 3.15234 22.8876C3.92797 23.6257 4.9541 24 6.20232 24H17.7585C19.0063 24 20.0324 23.6257 20.8083 22.8876C21.5938 22.1402 21.992 21.1256 21.992 19.8724C21.9918 19.3888 21.9755 18.9118 21.9435 18.4548ZM19.8385 21.8686C19.326 22.3564 18.6456 22.5935 17.7583 22.5935H6.20232C5.31481 22.5935 4.63439 22.3564 4.12207 21.8688C3.61944 21.3903 3.37518 20.7372 3.37518 19.8726C3.37518 19.4229 3.39001 18.9789 3.41967 18.5526C3.44861 18.1344 3.50775 17.675 3.59546 17.1868C3.68206 16.7047 3.79229 16.2522 3.9234 15.8426C4.04919 15.4499 4.22076 15.061 4.43353 14.6863C4.63659 14.3293 4.87023 14.0229 5.12805 13.7761C5.3692 13.5452 5.67315 13.3562 6.0313 13.2145C6.36254 13.0834 6.73479 13.0116 7.13891 13.0008C7.18816 13.027 7.27587 13.077 7.41796 13.1697C7.70708 13.3581 8.04033 13.573 8.40874 13.8083C8.82402 14.0731 9.35906 14.3122 9.99828 14.5186C10.6518 14.7299 11.3183 14.8372 11.9798 14.8372C12.6414 14.8372 13.3081 14.7299 13.9612 14.5188C14.601 14.3121 15.1358 14.0731 15.5517 13.808C15.9287 13.567 16.2526 13.3583 16.5417 13.1697C16.6838 13.0772 16.7715 13.027 16.8208 13.0008C17.2251 13.0116 17.5973 13.0834 17.9287 13.2145C18.2867 13.3562 18.5907 13.5454 18.8318 13.7761C19.0896 14.0227 19.3233 14.3291 19.5263 14.6865C19.7393 15.061 19.911 15.4501 20.0366 15.8424C20.1679 16.2526 20.2783 16.7049 20.3648 17.1866C20.4523 17.6757 20.5116 18.1353 20.5406 18.5528V18.5531C20.5704 18.9778 20.5854 19.4216 20.5856 19.8726C20.5854 20.7374 20.3412 21.3903 19.8385 21.8686Z"
                                  fill="#4B4B4B"
                                />
                              </svg>
                            </div>
                            <input
                              {...register("lastName_cl", {
                                required: "last name is required",
                              })}
                              name="lastName_cl"
                              onChange={onChangeHandlerClinic}
                              value={clinicSignup.lastName_cl}
                              placeholder="Your last name"
                              className=" outline-none px-2 border-none w-full"
                            />
                          </div>
                          {errors.lastName_cl ? (
                            <div className="w-[300px] text-red-500 text-sm ">
                              {errors.lastName_cl.message}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="w-[644px]   justify-center items-center inline-flex">
                        <div className="grow shrink  basis-0 self-stretch  flex-col justify-center items-start gap-[9px] inline-flex">
                          <div className="w-[306px] text-neutral-400 text-sm font-medium  font-poppins">
                            Hospital Name
                          </div>
                          <div
                            className={`${errors.hospital_name_cl
                              ? "border border-[#DD4243]"
                              : "border-blue-600"
                              } self-stretch h-12 pl-3 w-[644px] border  py-3 rounded-[10px]  justify-start items-start  inline-flex`}
                          >
                            <div className="w-6 h-6 relative flex-col justify-start items-start flex">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M2.5 22H21.5C21.6326 22 21.7598 21.9473 21.8536 21.8536C21.9473 21.7598 22 21.6326 22 21.5V9.5C22 9.36739 21.9473 9.24021 21.8536 9.14645C21.7598 9.05268 21.6326 9 21.5 9H19V4.5C19 4.36739 18.9473 4.24021 18.8536 4.14645C18.7598 4.05268 18.6326 4 18.5 4H16V3.5C16 3.10218 15.842 2.72064 15.5607 2.43934C15.2794 2.15804 14.8978 2 14.5 2H9.5C9.10218 2 8.72064 2.15804 8.43934 2.43934C8.15804 2.72064 8 3.10218 8 3.5V4H5.5C5.36739 4 5.24021 4.05268 5.14645 4.14645C5.05268 4.24021 5 4.36739 5 4.5V9H2.5C2.36739 9 2.24021 9.05268 2.14645 9.14645C2.05268 9.24021 2 9.36739 2 9.5V21.5C2 21.6326 2.05268 21.7598 2.14645 21.8536C2.24021 21.9473 2.36739 22 2.5 22ZM19 10H21V21H19V10ZM13.5 21H10.5V17.5H13.5V21ZM9 3.5C9 3.36739 9.05268 3.24021 9.14645 3.14645C9.24021 3.05268 9.36739 3 9.5 3H14.5C14.6326 3 14.7598 3.05268 14.8536 3.14645C14.9473 3.24021 15 3.36739 15 3.5V8.5C15 8.63261 14.9473 8.75979 14.8536 8.85355C14.7598 8.94732 14.6326 9 14.5 9H9.5C9.36739 9 9.24021 8.94732 9.14645 8.85355C9.05268 8.75979 9 8.63261 9 8.5V3.5ZM6 5H8V8.5C8 8.89782 8.15804 9.27936 8.43934 9.56066C8.72064 9.84196 9.10218 10 9.5 10H14.5C14.8978 10 15.2794 9.84196 15.5607 9.56066C15.842 9.27936 16 8.89782 16 8.5V5H18V21H14.5V17C14.5 16.8674 14.4473 16.7402 14.3536 16.6464C14.2598 16.5527 14.1326 16.5 14 16.5H10C9.86739 16.5 9.74021 16.5527 9.64645 16.6464C9.55268 16.7402 9.5 16.8674 9.5 17V21H6V5ZM3 10H5V21H3V10Z"
                                  fill="#4B4B4B"
                                />
                                <path
                                  d="M10.5 6.5H11.5V7.5C11.5 7.63261 11.5527 7.75979 11.6464 7.85355C11.7402 7.94732 11.8674 8 12 8C12.1326 8 12.2598 7.94732 12.3536 7.85355C12.4473 7.75979 12.5 7.63261 12.5 7.5V6.5H13.5C13.6326 6.5 13.7598 6.44732 13.8536 6.35355C13.9473 6.25979 14 6.13261 14 6C14 5.86739 13.9473 5.74021 13.8536 5.64645C13.7598 5.55268 13.6326 5.5 13.5 5.5H12.5V4.5C12.5 4.36739 12.4473 4.24021 12.3536 4.14645C12.2598 4.05268 12.1326 4 12 4C11.8674 4 11.7402 4.05268 11.6464 4.14645C11.5527 4.24021 11.5 4.36739 11.5 4.5V5.5H10.5C10.3674 5.5 10.2402 5.55268 10.1464 5.64645C10.0527 5.74021 10 5.86739 10 6C10 6.13261 10.0527 6.25979 10.1464 6.35355C10.2402 6.44732 10.3674 6.5 10.5 6.5Z"
                                  fill="#4B4B4B"
                                />
                                <path
                                  d="M8.5 12.5H9.5C9.63261 12.5 9.75979 12.4473 9.85355 12.3536C9.94732 12.2598 10 12.1326 10 12C10 11.8674 9.94732 11.7402 9.85355 11.6464C9.75979 11.5527 9.63261 11.5 9.5 11.5H8.5C8.36739 11.5 8.24021 11.5527 8.14645 11.6464C8.05268 11.7402 8 11.8674 8 12C8 12.1326 8.05268 12.2598 8.14645 12.3536C8.24021 12.4473 8.36739 12.5 8.5 12.5Z"
                                  fill="#4B4B4B"
                                />
                                <path
                                  d="M10 14.5C10 14.3674 9.94732 14.2402 9.85355 14.1464C9.75979 14.0527 9.63261 14 9.5 14H8.5C8.36739 14 8.24021 14.0527 8.14645 14.1464C8.05268 14.2402 8 14.3674 8 14.5C8 14.6326 8.05268 14.7598 8.14645 14.8536C8.24021 14.9473 8.36739 15 8.5 15H9.5C9.63261 15 9.75979 14.9473 9.85355 14.8536C9.94732 14.7598 10 14.6326 10 14.5Z"
                                  fill="#4B4B4B"
                                />
                                <path
                                  d="M11.5 12.5H12.5C12.6326 12.5 12.7598 12.4473 12.8536 12.3536C12.9473 12.2598 13 12.1326 13 12C13 11.8674 12.9473 11.7402 12.8536 11.6464C12.7598 11.5527 12.6326 11.5 12.5 11.5H11.5C11.3674 11.5 11.2402 11.5527 11.1464 11.6464C11.0527 11.7402 11 11.8674 11 12C11 12.1326 11.0527 12.2598 11.1464 12.3536C11.2402 12.4473 11.3674 12.5 11.5 12.5Z"
                                  fill="#4B4B4B"
                                />
                                <path
                                  d="M11.5 15H12.5C12.6326 15 12.7598 14.9473 12.8536 14.8536C12.9473 14.7598 13 14.6326 13 14.5C13 14.3674 12.9473 14.2402 12.8536 14.1464C12.7598 14.0527 12.6326 14 12.5 14H11.5C11.3674 14 11.2402 14.0527 11.1464 14.1464C11.0527 14.2402 11 14.3674 11 14.5C11 14.6326 11.0527 14.7598 11.1464 14.8536C11.2402 14.9473 11.3674 15 11.5 15Z"
                                  fill="#4B4B4B"
                                />
                                <path
                                  d="M14.5 12.5H15.5C15.6326 12.5 15.7598 12.4473 15.8536 12.3536C15.9473 12.2598 16 12.1326 16 12C16 11.8674 15.9473 11.7402 15.8536 11.6464C15.7598 11.5527 15.6326 11.5 15.5 11.5H14.5C14.3674 11.5 14.2402 11.5527 14.1464 11.6464C14.0527 11.7402 14 11.8674 14 12C14 12.1326 14.0527 12.2598 14.1464 12.3536C14.2402 12.4473 14.3674 12.5 14.5 12.5Z"
                                  fill="#4B4B4B"
                                />
                                <path
                                  d="M14.5 15H15.5C15.6326 15 15.7598 14.9473 15.8536 14.8536C15.9473 14.7598 16 14.6326 16 14.5C16 14.3674 15.9473 14.2402 15.8536 14.1464C15.7598 14.0527 15.6326 14 15.5 14H14.5C14.3674 14 14.2402 14.0527 14.1464 14.1464C14.0527 14.2402 14 14.3674 14 14.5C14 14.6326 14.0527 14.7598 14.1464 14.8536C14.2402 14.9473 14.3674 15 14.5 15Z"
                                  fill="#4B4B4B"
                                />
                              </svg>
                            </div>
                            <input
                              {...register("hospital_name_cl", {
                                required: "hospital name is required",
                              })}
                              name="hospital_name_cl"
                              onChange={onChangeHandlerClinic}
                              value={clinicSignup.hospital_name_cl}
                              placeholder="Your hospital name"
                              className=" outline-none px-2 border-none w-full"
                            />
                          </div>
                          {errors.hospital_name_cl ? (
                            <div className="w-[300px] text-red-500 text-sm ">
                              {errors.hospital_name_cl.message}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="self-stretch  flex-col justify-start items-start gap-2 flex">
                        <div className="w-[328px] text-neutral-400 text-sm font-medium  font-poppins">
                          Email
                        </div>
                        <div
                          className={`${errors.email_cl
                            ? "border border-[#DD4243]"
                            : "border-blue-600"
                            }
w-[644px] h-12 pl-3  py-3 rounded-[10px] border  justify-start items-start  inline-flex`}
                        >
                          <div className="w-6 h-6 relative flex-col justify-start items-start flex">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M21.6975 15.8335C21.6975 17.8601 20.0489 19.5062 18.0248 19.5062H5.97525C3.95114 19.5062 2.3025 17.8601 2.3025 15.8335V8.16649C2.3025 7.49008 2.4877 6.85479 2.80917 6.30954L8.68861 12.189C9.56822 13.0712 10.7461 13.5573 12.0013 13.5573C13.2538 13.5573 14.4317 13.0712 15.3113 12.189L21.1908 6.30954C21.5123 6.85479 21.6975 7.49004 21.6975 8.16649V15.8335H21.6975ZM18.0248 4.49378H5.97525C5.13938 4.49378 4.36777 4.77668 3.75052 5.24735L9.68911 11.1885C10.3038 11.8006 11.1242 12.1401 12.0013 12.1401C12.8757 12.1401 13.6962 11.8006 14.3108 11.1885L20.2494 5.24735C19.6322 4.77668 18.8607 4.49378 18.0248 4.49378ZM18.0248 3.07666H5.97525C3.16927 3.07666 0.885376 5.36055 0.885376 8.16654V15.8335C0.885376 18.6421 3.16927 20.9234 5.97525 20.9234H18.0248C20.8307 20.9234 23.1146 18.6421 23.1146 15.8335V8.16649C23.1146 5.3605 20.8307 3.07666 18.0248 3.07666Z"
                                fill="#4B4B4B"
                              />
                            </svg>
                          </div>
                          <input
                            {...register("email_cl", {
                              required: "email is required",
                              pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                message: "Invalid email address",
                              },
                            })}
                            name="email_cl"
                            onChange={onChangeHandlerClinic}
                            value={clinicSignup.email_cl}
                            placeholder="Someone@examplehospital.com"
                            className=" outline-none px-2 border-none w-full"
                          />
                        </div>
                        {errors.email_cl ? (
                          <div className="w-[328px] text-red-500 text-sm ">
                            {errors.email_cl.message}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="w-[644px]  gap-8 inline-flex">
                        <div className="grow shrink basis-0 self-stretch pt-0.5 flex-col justify-center items-start gap-[9px] inline-flex">
                          <div className="w-[306px] text-neutral-400 text-sm font-medium  font-poppins">
                            Password
                          </div>
                          <div
                            className={`${errors.password_cl
                              ? "border border-[#DD4243]"
                              : "border-blue-600"
                              } self-stretch h-12 px-2  py-3 rounded-[10px] border  justify-between w-full items-start  inline-flex`}
                          >
                            <input
                              {...register("password_cl", {
                                required: "password is required",
                                pattern: {
                                  value:
                                    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
                                  message:
                                    "Password must include at least one letter, one number, and one special character, and be at least 6 characters long",
                                },
                              })}
                              name="password_cl"
                              placeholder="Enter Password"
                              value={clinicSignup.password_cl}
                              onChange={onChangeHandlerClinic}
                              type={isPasswordVisible ? "text" : "password"}
                              className="w-full px-2 border-none outline-none"
                            />
                            <div
                              onClick={togglePasswordVisibility}
                              className="cursor-pointer"
                            >
                              {isPasswordVisible ? (
                                <Image src={"/Images/view.svg"}  width={24} height={24} alt="" />
                              ) : (
                                <Image src={"/Images/Hide.svg"}  width={24} height={24}  alt="" />
                              )}
                            </div>
                          </div>
                          {errors.password_cl ? (
                            <div className="w-[300px]  text-red-500 text-sm ">
                              {errors.password_cl.message}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="grow shrink basis-0 self-stretch pt-0.5 flex-col justify-center items-start gap-[9px] inline-flex">
                          <div className="w-[306px] text-neutral-400 text-sm font-medium  font-poppins">
                            Confirm Password
                          </div>
                          <div
                            className={`${errors?.confirmPassword_cl?.message ===
                              "confirm password is required" ||
                              errors?.confirmPassword_cl?.message ===
                              "password do not match with confirm password"
                              ? " border-[#DD4243]"
                              : "border-blue-600"
                              }  self-stretch h-12 px-2  py-3 rounded-[10px] border  justify-start items-start  inline-flex `}
                          >
                            <input
                              {...register("confirmPassword_cl", {
                                required: "confirm password is required",

                                validate: (value) =>
                                  value === clinicSignup?.password_cl ||
                                  "password do not match with confirm password",
                              })}
                              name="confirmPassword_cl"
                              value={clinicSignup?.confirmPassword_cl}
                              onChange={onChangeHandlerClinic}
                              type={"password"}
                              placeholder="Enter confirm password"
                              className="w-full px-2 border-none outline-none"
                            />
                            {/* <div
                              onClick={togglePasswordVisibility}
                              className="cursor-pointer"
                            >
                              {isPasswordVisible ? (
                                <Image src={ShowEye}  alt="" />
                              ) : (
                                <Image src={CloseEye}  alt="" />
                              )}
                            </div> */}
                          </div>
                          {errors?.confirmPassword_cl?.message ===
                            "confirm password is required" ? (
                            <div className="w-[300px] text-red-500 text-sm mt-2">
                              {errors?.confirmPassword_cl?.message}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {errors?.confirmPassword_cl?.message ===
                        "password do not match with confirm password" ? (
                        <div className="w-[300px] text-red-500 text-sm ">
                          {errors?.confirmPassword_cl?.message}
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="self-stretch  flex-col justify-start items-start gap-2 flex">
                        <div className="w-[328px] text-neutral-400 text-sm font-medium  font-poppins">
                          NPI Number (Optional)
                        </div>
                        <div
                          className={`${npmErrorClinic?.error
                            ? " border-[#DD4243]"
                            : "border-blue-600"
                            } w-[644px] h-12 pl-3  py-3 rounded-[10px] border justify-start items-start gap-[11px] inline-flex`}
                        >
                          <div className="w-6 h-6 relative flex-col justify-start items-start flex">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M4.16437 16.3488C3.97237 16.3488 3.78075 16.2757 3.63412 16.1291C3.34125 15.8362 3.34125 15.3614 3.63412 15.0686L15.3544 3.34832C15.6469 3.05544 16.122 3.05544 16.4149 3.34832C16.7077 3.64119 16.7077 4.11594 16.4149 4.40882L4.69462 16.1291C4.54837 16.2753 4.35637 16.3488 4.16437 16.3488Z"
                                fill="#4B4B4B"
                              />
                              <path
                                d="M3.00638 21.75C2.95425 21.75 2.90138 21.7444 2.8485 21.7332C2.4435 21.6462 2.1855 21.2475 2.2725 20.8425L3.43125 15.4414C3.51825 15.0364 3.91875 14.7792 4.32188 14.8654C4.72688 14.9524 4.98488 15.351 4.89788 15.756L3.73913 21.1572C3.66375 21.5093 3.3525 21.75 3.00638 21.75Z"
                                fill="#4B4B4B"
                              />
                              <path
                                d="M8.40675 20.5912C8.21475 20.5912 8.02313 20.5181 7.8765 20.3715C7.58363 20.0786 7.58363 19.6039 7.8765 19.311L19.5968 7.59112C19.8893 7.29824 20.3644 7.29824 20.6573 7.59112C20.9501 7.88399 20.9501 8.35874 20.6573 8.65162L8.93738 20.3715C8.79075 20.5181 8.59875 20.5912 8.40675 20.5912Z"
                                fill="#4B4B4B"
                              />
                              <path
                                d="M3.00488 21.75C2.65875 21.75 2.34788 21.5092 2.27213 21.1571C2.1855 20.7521 2.44313 20.3535 2.84813 20.2665L8.24925 19.1077C8.65463 19.0218 9.05325 19.2791 9.13988 19.6837C9.2265 20.0887 8.96888 20.4873 8.56388 20.5743L3.16275 21.7331C3.10988 21.7447 3.057 21.75 3.00488 21.75Z"
                                fill="#4B4B4B"
                              />
                              <path
                                d="M18.0056 10.9924C17.8136 10.9924 17.6216 10.9193 17.4754 10.7727L13.233 6.53028C12.9401 6.2374 12.9401 5.76265 13.233 5.46978C13.5255 5.1769 14.001 5.1769 14.2935 5.46978L18.5359 9.71215C18.8288 10.005 18.8288 10.4798 18.5359 10.7727C18.3896 10.9193 18.1976 10.9924 18.0056 10.9924Z"
                                fill="#4B4B4B"
                              />
                              <path
                                d="M20.127 8.87135C19.935 8.87135 19.743 8.79822 19.5964 8.6516C19.3035 8.35872 19.3035 7.88397 19.5964 7.59072C20.0138 7.17335 20.2436 6.60822 20.2436 5.99997C20.2436 5.39172 20.0138 4.8266 19.5964 4.40922C19.1786 3.99147 18.6135 3.7616 18.0053 3.7616C17.397 3.7616 16.8319 3.99147 16.4145 4.40922C16.122 4.7021 15.6473 4.70247 15.3536 4.40922C15.0608 4.11635 15.0608 3.6416 15.3536 3.34835C16.0541 2.64747 16.9958 2.2616 18.0053 2.2616C19.0144 2.2616 19.9564 2.64747 20.6569 3.34835C21.3578 4.04885 21.7436 4.99047 21.7436 5.99997C21.7436 7.00947 21.3578 7.9511 20.6569 8.6516C20.511 8.79785 20.319 8.87135 20.127 8.87135Z"
                                fill="#4B4B4B"
                              />
                            </svg>
                          </div>
                          <input
                            {...register("npi_number_cl", {
                              pattern: {
                                value: /^\d{10}$/,
                                message: "NPI number should be 10 digit*",
                              },
                            })}
                            name="npi_number_cl"
                            onChange={onChangeHandlerClinic}
                            value={clinicSignup.npi_number_cl}
                            placeholder="Your NPI number"
                            className=" outline-none border-none w-full"
                          />
                        </div>
                        {errors?.npi_number_cl?.message ? (
                          <div className="w-[300px] text-red-500 text-sm ">
                            {errors?.npi_number_cl?.message}
                          </div>
                        ) : (
                          ""
                        )}
                        {npmErrorClinic?.error ? (
                          <div className="w-[300px] text-red-500 text-sm ">
                            {npmErrorClinic?.error}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="w-[644px] justify-center items-start gap-8 inline-flex">
                        <button 
                          onClick={handleReset} 
                          className="grow w-[305px] cursor-pointer shrink basis-0 self-stretch px-4 py-3 rounded-[10px] border border-blue-600 justify-center items-center gap-2.5 inline-flex">
                          <div className="text-blue-600 text-base font-medium font-poppins">
                            {isResetting ? "Resetting..." : "Reset"}
                          </div>
                        </button>
                        <button type="submit">
                          <div className="grow w-[305px] cursor-pointer shrink basis-0 self-stretch px-4 py-3 bg-blue-600 rounded-[10px] justify-center items-center gap-2.5 inline-flex">
                            <div className="text-white text-base font-medium  font-poppins">
                              {load ? "Loading..." : "Sign Up"}
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <span className="text-neutral-400 text-sm font-medium  font-poppins">
                      Already have an account?{" "}
                    </span>
                    <a onClick={(e) => {
                      e.preventDefault();
                      handleNavigation("login");
                    }}>
                      <span className="text-blue-600 text-sm cursor-pointer font-medium  font-poppins underline">
                        Log In
                      </span>
                    </a>
                  </div>
                </div>
              </form>
            )}
            {activeTab === 2 && (
            <div className="leading-tight text-base sm:text-[20px] font-semibold mt-4 sm:mt-6 pb-4 sm:pb-0">
              For information on hospital or group sign-ups, please contact us at &nbsp; <Link className="underline text-blue-600" href='/contact-us'><span>Contact</span></Link>.
            </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
